import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "[appPercentageDirective]"
})
export class PercentageDirective {
    private regex: RegExp = new RegExp(/^(100|\d{0,2})(\.\d{0,4})?$/);
    private specialKeys: Array<string> = [
        "Backspace", "Tab", "End", "Home", "ArrowLeft", "ArrowRight", "Delete"
    ];

    constructor(private el: ElementRef) { }

    @HostListener("keydown", ["$event"])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.includes(event.key)) {
            return; 
        }

        let current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [
            current.slice(0, position),
            event.key === "Decimal" ? "." : event.key,
            current.slice(position)
        ].join("");

        if (!/^\d|\.$/.test(event.key)) {
            event.preventDefault();
            return;
        }

        if (next === "00") {
            event.preventDefault();
            return;
        }

        if (next.startsWith(".")) {
            event.preventDefault();
            return;
        }

        const [beforeDecimal, afterDecimal] = next.split(".");

        if (beforeDecimal && parseInt(beforeDecimal, 10) > 100) {
            event.preventDefault();
            return;
        }

        if (beforeDecimal && beforeDecimal.length > 3) {
            event.preventDefault();
            return;
        }

        if (afterDecimal && afterDecimal.length > 4) {
            event.preventDefault();
            return;
        }

        if (!this.regex.test(next)) {
            event.preventDefault();
        }
    }
}
